import React from 'react';
import Slider from 'react-slick';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import './carousel.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useTranslation } from 'react-i18next';

// Custom Next Arrow
const NextArrow = (props) => {
    const { onClick } = props;
    return (
        <div className="custom-arrow custom-next" onClick={onClick}>
            <BsChevronRight size={20} />
        </div>
    );
};

// Custom Prev Arrow
const PrevArrow = (props) => {
    const { onClick } = props;
    return (
        <div className="custom-arrow custom-prev" onClick={onClick}>
            <BsChevronLeft size={20} />
        </div>
    );
};

const Carousel360 = ({ images }) => {
    const { i18n } = useTranslation();
    const isRTL = i18n.language === 'ar';

    const settings = {
        className: "center",
        centerMode: true,
        infinite: true,
        centerPadding: "0px",
        slidesToShow: 3,
        speed: 500,
        // focusOnSelect: true, // Disabled to prevent page jump
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        rtl: isRTL,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: "0px",
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    centerPadding: "0px",
                }
            }
        ]
    };

    // If no images provided, return null or placeholder
    if (!images || images.length === 0) {
        return <div className="text-center p-4">No images to display</div>;
    }

    return (
        <div className="carousel-wrapper">
            <div className="row justify-content-center">
                <div className="col-12">
                    <div className="carousel-container">
                        <Slider {...settings}>
                            {images.map((imgSrc, index) => (
                                <div key={index} className="px-2">
                                    <div className="img-card">
                                        <img src={imgSrc} alt={`Slide ${index}`} />
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Carousel360;
